import { render, staticRenderFns } from "./legalStatement.vue?vue&type=template&id=fcbc65c4&scoped=true&"
import script from "./legalStatement.vue?vue&type=script&lang=js&"
export * from "./legalStatement.vue?vue&type=script&lang=js&"
import style0 from "./legalStatement.vue?vue&type=style&index=0&id=fcbc65c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbc65c4",
  null
  
)

export default component.exports